import React from "react";
import { withRouter } from "react-router-dom";
import StatusBadge from "../components/StatusBadge";
import Table from "../components/Table";
import TitleBar from "../components/TitleBar";
import Header from "../components/Header";
import NavigationSideBar from "../components/NavigationSideBar";
import InnerBody from "../components/InnerBody";
import ClientPicture from "../components/ClientPicture";
import withAuthorization from "../firebase/withAuthorization";
import { getClientUpdates, createNewClient } from "../firebase/firestore";
import RaisedButton from "../components/RaisedButton";
import Dialog from "../components/Dialog";
import TextInput from "../components/TextInput";
import { dateToStringShort } from "../utils/DateHelper";
import FileInput from "../components/FileInput";
import withAccount from "../utils/withAccount";

class PageClients extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      clients: [],

      addClientDialogVisible:
        this.props.location.hash.substring(1, 1000) === "add"
    };

    this.refAddName = React.createRef();
    this.refAddLogo = React.createRef();
    this.refAddFirst = React.createRef();
    this.refAddLast = React.createRef();
    this.refAddEmail = React.createRef();

    this.clientsListenerUnsub = null;
  }

  componentDidMount() {
    this.fetchData();
  }

  componentWillUnmount() {
    if (this.clientsListenerUnsub) this.clientsListenerUnsub();
  }

  fetchData() {
    const { account } = this.props;
    this.clientsListenerUnsub = getClientUpdates(account.id, docs => {
      let clients = [];

      docs.forEach(element => {
        let data = element.data();

        //Safe
        if (element.id && data.name && data.created)
          clients.push({
            id: element.id,
            name: data.name,
            created: data.created,
            status: ""
          });
      });

      this.setState({ clients: clients, isLoading: false });
    });
  }

  createClientDataArray() {
    const { account } = this.props;
    const { clients } = this.state;

    let data = [];
    clients.forEach(c => {
      data.push({
        items: [
          <span className="AlignVerti">
            <ClientPicture small clientId={c.id} account={account} />
            <div className="Spacer-HS" />
            {c.name}
          </span>,
          dateToStringShort(c.created.toDate()),
          <p className="Link">
            <i
              className="fas fa-cog"
              style={{ textAlign: "center", width: "100%" }}
            />
          </p>
        ]
      });
    });

    return data;
  }

  openAddClientDialog() {
    const oName = this.refAddName.current.state;
    const cFirst = this.refAddFirst.current.state;
    const cLast = this.refAddLast.current.state;
    const cEmail = this.refAddEmail.current.state;
    oName.reset();
    cFirst.reset();
    cLast.reset();
    cEmail.reset();

    this.setState({ addClientDialogVisible: true });
  }

  addClient() {
    const { account } = this.props;

    //Get
    const oName = this.refAddName.current.state;
    const oLogo = this.refAddLogo.current.state;
    const cFirst = this.refAddFirst.current.state;
    const cLast = this.refAddLast.current.state;
    const cEmail = this.refAddEmail.current.state;

    if (
      oName.isValid &&
      oLogo.isValid &&
      cFirst.isValid &&
      cLast.isValid &&
      cEmail.isValid
    ) {
      const newClient = {
        name: oName.value,
        contact_person: {
          first: cFirst.value,
          last: cLast.value,
          email: cEmail.value
        }
      };

      createNewClient(
        account.id,
        newClient,
        oLogo.file,
        success => {},
        error => {}
      );
      this.setState({ addClientDialogVisible: false });
    }
  }

  render() {
    const { clients, addClientDialogVisible } = this.state;

    return (
      <div>
        <Header
          title="Kunden"
          showProjectsDropdown={false}
          showProfile={true}
        />
        <NavigationSideBar page="clients" />
        <InnerBody isLoading={this.state.isLoading}>
          <TitleBar title="Kunden">
            <RaisedButton
              label="Neuen Kunden anlegen"
              onClick={() => this.openAddClientDialog()}
            />
          </TitleBar>
          <Table
            header={[
              {
                items: ["Kunde", "Erstellt", ""]
              }
            ]}
            onItemSelected={(index, col) => {
              if (col !== 2) {
                this.props.history.push(`/dash/projects/${clients[index].id}`);
              } else {
                this.props.history.push(`clients/${clients[index].id}`);
              }
            }}
            colSelectables={[2]}
            data={this.createClientDataArray()}
          >
            <p>
              Fangen wir damit an, oben rechts einen neuen Kunden anzulegen.
            </p>
          </Table>
        </InnerBody>

        <Dialog
          title="Neuen Kunden anlegen"
          action="Kunden Anlegen"
          visible={addClientDialogVisible}
          onAccept={() => this.addClient()}
          onClose={() => this.setState({ addClientDialogVisible: false })}
        >
          <p>Unternehmen</p>
          <TextInput
            placeholder="Name"
            minLength={2}
            maxLength={30}
            ref={this.refAddName}
          />
          <FileInput placeholder="Logo Auswählen" ref={this.refAddLogo} />
          <p style={{ marginTop: 16 }}>
            Kontaktperson&nbsp;
            <small>(Diese Person wird die Freigaben machen)</small>
          </p>
          <TextInput
            placeholder="Vorname"
            minLength={2}
            maxLength={25}
            ref={this.refAddFirst}
          />
          <TextInput
            placeholder="Nachnahme"
            minLength={2}
            maxLength={25}
            ref={this.refAddLast}
          />
          <TextInput
            placeholder="E-Mail"
            validation="email"
            ref={this.refAddEmail}
          />
          <p>&nbsp;</p>
        </Dialog>
      </div>
    );
  }
}

const authCondition = authUser => !!authUser;
export default withAuthorization(authCondition)(
  withRouter(withAccount(PageClients))
);



// WEBPACK FOOTER //
// ./src/pages/PageClients.js